<template>
    <AppModal :override-visibility="true"
              :is-really-visible="isVisible"
              :max-size="true"
              @dismiss="$emit('hide-channel-lineup')">
        <template #contents>
            <div class="flex
                        flex-col desktop:flex-row
                        justify-between
                        items-center
                        mb-4">
                <div class="text-base desktop:text-xl
                            font-bold">
                    Channel Lineup
                </div>
                <div class="text-base desktop:text-lg
                            text-right">
                    {{ meta.city }}, {{ meta.stateOrProvince }} {{ meta.postalCode }}
                </div>
            </div>
            <span class="text-salmon font-bold text-sm">* Channel Number</span>
            <div class="grid
                        grid-cols-12
                        gap-6">
                <div class="hidden desktop:block
                            col-span-8">
                    <table class="striped-rows">
                        <thead>
                            <tr>
                                <th>Locals+ ({{ localsPlus.length }})</th>
                                <th>Variety+ ({{ varietyPlus.length }})</th>
                                <th>Family+ ({{ familyPlus.length }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(rowNumber, index) in maxRows"
                                :key="index">
                                <td>
                                    <template v-if="localsPlus[index]">
                                     <span class="text-salmon font-bold">{{ localsPlus[index].channelNo }}</span> {{ localsPlus[index].channelName }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="varietyPlus[index]">
                                       <span class="text-salmon font-bold">{{ varietyPlus[index].channelNo }}</span> {{ varietyPlus[index].channelName }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="familyPlus[index]">
                                       <span class="text-salmon font-bold">{{ familyPlus[index].channelNo }}</span> {{ familyPlus[index].channelName }}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-for="pkg in allPackages"
                     :key="pkg.title"
                     class="desktop:hidden
                            col-span-12">
                    <table class="striped-rows">
                        <thead>
                            <tr>
                                <th>{{ pkg.title }} ({{ pkg.items.length }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in pkg.items"
                                :key="index">
                                <td>
                                   <span class="text-salmon font-bold">{{ item.channelNo }}</span> {{ item.channelName }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-span-12 desktop:col-span-4">
                    <table class="striped-cats">
                        <thead>
                            <tr>
                                <th>Add-Ons ({{ addOns.length }})</th>
                            </tr>
                        </thead>
                        <tbody v-for="cat in addOnsCats" 
                               :key="cat">
                            <tr class="cat">
                                <td class="font-bold">
                                    {{ cat }}
                                </td>
                            </tr>
                            <tr v-for="channel in addOnsCategorized[cat]"
                                :key="channel.id">
                                <td>
                                    <span class="text-salmon font-bold">{{ channel.channelNo }}</span> {{ channel.channelName }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </AppModal>
</template>

<script>
    import AppModal from '~/Buyflow/components/AppModal'

    export default {
        name: 'TVChannelLineup',
        components: {
            AppModal,
        },
        props: {
            meta: {
                type: Object,
                required: true,
            },
            filteredChannels: {
                type: Object,
                default: () => ({
                    localsPlus: [],
                    varietyPlus: [],
                    familyPlus: [],
                    addOns: [],
                }),
            },
            isVisible: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            // shortcuts
            localsPlus () {
                return this.filteredChannels.localsPlus
            },
            varietyPlus () {
                return this.filteredChannels.varietyPlus
            },
            familyPlus () {
                return this.filteredChannels.familyPlus
            },
            maxRows (state, getters) {
                return Math.max(this.localsPlus.length,
                                this.varietyPlus.length,
                                this.familyPlus.length)
            },
            allPackages () {
                return [
                    {
                        title: 'Locals+',
                        items: this.localsPlus,
                    },
                    {
                        title: 'Variety+',
                        items: this.varietyPlus,
                    },
                    {
                        title: 'Family+',
                        items: this.familyPlus,
                    },
                ]
            },
            addOns () {
                return this.filteredChannels.addOns
            },
            addOnsCategorized() {
                let res = {}

                this.addOns.forEach(channel => {
                    let cat = channel.subCategory

                    if (!res[cat]) {
                        res[cat] = []
                    }

                    res[cat].push(channel)
                })

                return res
            },
            addOnsCats() {
                return Object.keys(this.addOnsCategorized).sort()
            },
        },
    }
</script>

<style lang="scss" scoped>
    table {
        @apply border
               border-gray-200
               border-collapse
               w-full;

        thead {
            @apply bg-gray-100;
        }

        th, td {
            @apply border
                   border-gray-200
                   desktop:whitespace-nowrap
                   p-2;
        }

        th {
            @apply text-sm desktop:text-base
                   font-bold;
        }

        td {
            @apply text-sm;
        }
    }

    table.striped-rows {
        tr:nth-child(even) {
            @apply bg-gray-50;
        }
    }

    table.striped-cats {
        .cat {
            @apply bg-gray-50;
        }
    }

    table.numbered {
        td:first-child {
            @apply text-center
                   font-bold;
        }
    }
</style>